import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import Modal from "../../common/Modal/Modal";
import {addProject, getCompanyPojects, clearProject} from "../../../actions/projects";
import {respondToContractInvitation, respondToApprovalInvitation, createContract} from "../../../actions/contract";

export function ContractCreateModal(props) {

const contract = useSelector(state => state.contract.contract);
const project = useSelector(state => state.projects.project);
const projectDrop = useSelector(state => state.projects.projectDrop);
const company_projects = useSelector(state => state.projects.company_projects);

const [companyCreatorType, setCompanyCreatorType] = useState(null);
const [existingProject, setExistingProject] = useState(projectDrop.project_id ? projectDrop.project_id : null);
const [createNew, setCreateNew] = useState(false);
const newProjectInitial = {
    project_name: null,
    country: null,
    street: null,
    city: null,
}
const [newProject, setNewProject] = useState(newProjectInitial);
const [submitting, setSubmitting] = useState(false);


// ON MOUNT GET PROJECT OPTIONS
useEffect(() => {
    project.project_id && props.clearProject();
    props.getCompanyPojects();
}, [])


// SELECT AN EXISTING PROJECT
const handleSelectExisting = (e) => {
    e.preventDefault();
    createNew && setCreateNew(false);
    (newProject.project_name || newProject.country || newProject.street || newProject.city) && setNewProject(newProjectInitial);
    setExistingProject(e.target.value);
}


// START CREATING NEW PROJECT
const handleStartNew = (e) => {
    e.preventDefault(e)
    setCreateNew(true);
    existingProject && setExistingProject(null);
}


// EDIT VALUES FOR NEW PROJECT
const handleChangeNewProject = (e) => {
    existingProject && setExistingProject(null);
    setNewProject({...newProject, [e.target.name]: e.target.value})
}


// DISABLE FORM SUBMIT if missing any of project, creator type, or already submitting
const disableSubmit = !companyCreatorType || (!newProject.project_name && !existingProject) || submitting



// SUBMIT FORM ---------------------------------
const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    if (existingProject) { 
        // create contract with this project
        const newContract = {pid: existingProject, "company_creator_type": companyCreatorType}
        props.createContract(newContract);
    } else {
        props.addProject(newProject);
    }
} 
    // SUCCESSFUL PROJECT CREATION - NOW CREATE CONTRACT
    useEffect(() => {
        if (project.project_id && submitting) { // *** create contract, close modal when contract id comes back successfully
            const newContract = {pid: project.project_id, "company_creator_type": companyCreatorType}
            props.createContract(newContract);
        }
    }, [project.project_id, submitting]);

    // SUCCESSFUL CONTRACT CREATION - CLOSE MODAL
    useEffect(() => {
        if (submitting && contract.contract_id) {
            props.setModalOpen(false);
        }
    }, [contract.contract_id]);
// -------------------------------------------




    return (
        <Modal blurBack={true} hasCloseButton={true} hideLogo handleClose={() => props.setModalOpen(false)} >
                <div className="flex-column w100" >
                    <form onSubmit={(e) => handleSubmit(e)} className="form" >
                    <h3 className="title2 gap-below-m heavy t-center">Create a New Contract</h3>

                        <h4 className="content1 heavy gap-below-xxs">Contract type</h4>
                        <div className="checkbox-wrapper gap-below-xs" onClick={(e) => setCompanyCreatorType("Purchaser")}>
                            <input 
                                className="typical-checkbox"
                                type="checkbox"
                                id="Purchaser"
                                name="Purchaser"
                                // value={!props.newCompany.register_domain}
                                checked={companyCreatorType === "Purchaser"}
                                onChange={(e) => setCompanyCreatorType("Purchaser")}
                            />
                            <label htmlFor="AP" className="content2 light-black multiline" >Represent the Purchaser (receive invoices)</label>
                        </div>
                        <div className="checkbox-wrapper gap-below-m" >
                            <input 
                                className="typical-checkbox"
                                type="checkbox"
                                id="Vendor"
                                name="Vendor"
                                // value={!props.newCompany.register_domain}
                                checked={companyCreatorType === "Vendor"}
                                onChange={(e) => setCompanyCreatorType("Vendor")}
                            />
                            <label htmlFor="Vendor" className="content2 light-black multiline" >Represent the Vendor (send invoices)</label>
                        </div>

                        <h4 className="content1 heavy gap-below-xxs">Select a Parent Project</h4>
                        <div className="inputs-wrapper gap-below-s">
                            <div className="input-basic">										
                                <select 
                                    name="project_id" 
                                    id="project_id" 
                                    style={existingProject ? {color: "#3C3B41" } : {color: "#919197"}}
                                    onChange={(e) => handleSelectExisting(e)}
                                    value={existingProject ? existingProject : ""}
                                    required={!createNew}
                                >
                                    <option value={""} >Select a project</option>
                                    {company_projects && company_projects.map((project) => {
                                        return <option key={project.project_id} value={project.project_id} >{project.project_name}</option>
                                    })}
                                </select>
                                <label htmlFor="name">Existing Project {!createNew &&<span>*</span>}</label>
                            </div>
                        </div>
                        <div className="gap-below-m">
                            <h4 className="content1 light-black gap-below-xxs">Or create a&nbsp;
                                <button id="contract_create_project" 
                                    className="link1" 
                                    onClick={(e) => handleStartNew(e)}> new project +</button>
                            </h4>
                            {createNew &&
                            <div className="inputs-wrapper gap-below-m"> 
                                <div className="input-basic">										
                                    <input
                                        type="text"
                                        name="project_name"
                                        id="project_name"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="project_name">Project Name {createNew && <span>*</span>}</label>
                                </div>
                                <div className="input-basic">
                                    <input
                                        type="text"
                                        name="country"
                                        id="country"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="country">Country {createNew && <span>*</span>}</label>
                                </div>
                                <div className="input-basic">
                                    <input
                                        type="text"
                                        name="street"
                                        id="street"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="street">Street Address {createNew && <span>*</span>}</label>
                                </div>
                                <div className="input-basic">
                                    <input
                                        type="text"
                                        name="city"
                                        id="city"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="city">City {createNew && <span>*</span>}</label>
                                </div>                   
                            </div>}
                        </div>
                        <div className="flex-row">
                            <button id="save_to_project" className="btn pri expand gap-right-xs" type="submit" disabled={disableSubmit}>{submitting ? "Please wait..." : "Create Contract"}</button>
                            <button 
                                className="btn sec expand" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.setModalOpen(false)
                                }}>Cancel
                            </button>
                        </div>
                    </form>
                </div>    
        </Modal>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {addProject, createContract, respondToApprovalInvitation, getCompanyPojects, clearProject, respondToContractInvitation})(ContractCreateModal);